import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./popover.html";
import { getFocusTrap } from '~/modules/helpers/focusTrap';
import { selectSharedLabels, WireI18n } from '~/modules/stores/i18nStore';
import { handleScrollLock } from '~/modules/utilities/browser';
export let PopoverVerticalOrientation = /*#__PURE__*/function (PopoverVerticalOrientation) {
  PopoverVerticalOrientation["TOP"] = "top";
  PopoverVerticalOrientation["BOTTOM"] = "bottom";
  return PopoverVerticalOrientation;
}({});
export let PopoverHorizontalOrientation = /*#__PURE__*/function (PopoverHorizontalOrientation) {
  PopoverHorizontalOrientation["RIGHT"] = "right";
  PopoverHorizontalOrientation["LEFT"] = "left";
  PopoverHorizontalOrientation["CENTER"] = "center";
  return PopoverHorizontalOrientation;
}({});
class Popover extends LightningElement {
  constructor(...args) {
    super(...args);
    this.show = false;
    this.ariaLabel = null;
    this.hideCloseButton = false;
    this.popoverOrientation = {
      vertical: PopoverVerticalOrientation.BOTTOM,
      horizontal: PopoverHorizontalOrientation.LEFT
    };
    this.ariaLabelledBy = null;
    this.labels = void 0;
    // If a popover is showing, check that the click on document.
    // Body is happening outside of the popover. If it is, close the popover.
    this.createCatchClickHandler = async e => {
      if (this.show) {
        const composedPath = e.composedPath();
        // @ts-expect-error * Automated Type Error Fix
        const externalClick = !composedPath.includes(this.template.querySelector('.popover-wrapper'));
        // @ts-expect-error * Automated Type Error Fix
        const toolTipClick = composedPath.includes(this.template.querySelector('.popover-trigger'));
        if (externalClick && !toolTipClick) {
          // Returns the scroll position to the same position after the this.handleClose()
          handleScrollLock(() => {
            this.handleClose();
          });
        }
      }
    };
  }
  connectedCallback() {
    document.addEventListener('mousedown', this.createCatchClickHandler);
  }
  disconnectedCallback() {
    document.removeEventListener('mousedown', this.createCatchClickHandler);
  }
  renderedCallback() {
    if (!this.ariaLabel) {
      // @ts-expect-error * Automated Type Error Fix
      this.ariaLabelledBy = 'popover-content';
    }
    if (this.show) {
      const slotElement = this.template.querySelector('.popover');
      if (!slotElement) {
        return;
      }
      this.focusTrap = getFocusTrap(slotElement);
      this.focusTrap?.focusFirstElement();
    }
  }
  get popoverClass() {
    const {
      vertical,
      horizontal
    } = this.popoverOrientation;
    return `popover vertical-${vertical} horizontal-${horizontal}`;
  }
  get arrowClass() {
    const {
      vertical,
      horizontal
    } = this.popoverOrientation;
    return `arrow vertical-${vertical} horizontal-${horizontal}`;
  }
  get contentClass() {
    return this.hideCloseButton ? 'content' : 'close-button-content';
  }
  get closeButtonAriaLabel() {
    return this.labels?.close ?? '';
  }
  handleClose() {
    this.dispatchEvent(new CustomEvent('close'));
  }

  // @ts-expect-error * Automated Type Error Fix
  handleInputKey(event) {
    if (event.key === 'Tab') {
      if (event.shiftKey) {
        this.handlePrevFocus(event);
      } else {
        this.handleNextFocus(event);
      }
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handleNextFocus(event) {
    const {
      focusNext
    } = this.focusTrap;
    const {
      shouldPreventDefault
    } = focusNext();
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }

  // @ts-expect-error * Automated Type Error Fix
  handlePrevFocus(event) {
    const {
      focusPrevious
    } = this.focusTrap;
    const {
      shouldPreventDefault
    } = focusPrevious();
    if (shouldPreventDefault) {
      event.preventDefault();
    }
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(Popover, {
  publicProps: {
    show: {
      config: 0
    },
    ariaLabel: {
      config: 0
    },
    hideCloseButton: {
      config: 0
    },
    popoverOrientation: {
      config: 0
    }
  },
  wire: {
    labels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectSharedLabels
        };
      }
    }
  },
  fields: ["ariaLabelledBy", "createCatchClickHandler"]
});
const __lwc_component_class_internal = _registerComponent(Popover, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;